<template>
  <v-app-bar 
    app 
    flat 
    height="70"
    class="app-bar-root"
  >
    <div class="app-bar-container">
      <!-- <div class="d-flex align-center "  style="margin-bottom: 20px">
        <v-btn
          v-if="$vuetify.breakpoint.mdAndDown"
          icon
          @click="$emit('toggle-drawer')"
          class="mr-2"
        >
          <v-icon color="#64748b">mdi-menu-variant</v-icon>
        </v-btn>

        <div class="header-breadcrumb d-none d-sm-flex align-center">
          <span class="txt-caption slate-400">Pages</span>
          <v-icon x-small class="mx-2" color="#cbd5e1">mdi-chevron-right</v-icon>
          <span class="txt-subtitle slate-700">{{ $route.name || "Dashboard" }}</span>
        </div>
      </div> -->

      <v-spacer />

      <div class="d-flex align-center" style="margin-bottom: 20px">
        <div class="v-divider-vertical mx-4"></div>

        <v-menu
          offset-y
          transition="slide-y-transition"
          nudge-bottom="12"
          content-class="menu-dropdown-shadow rounded-xl"
        >
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="profile-pill">
              <v-avatar size="34" class="shadow-sm">
                <v-img :src="`https://ui-avatars.com/api/?name=${user.firstName}+${user.lastName}&background=4f46e5&color=fff&bold=true`" />
              </v-avatar>

              <div class="profile-info d-none d-lg-block">
                <div class="u-name text-truncate">{{ user.firstName }}</div>
                <div class="u-role">
                  <span class="status-indicator"></span>
                  {{ user.nickName || "Admin" }}
                </div>
              </div>

              <v-icon size="18" class="ml-2 grey--text text--lighten-1">mdi-chevron-down</v-icon>
            </div>
          </template>

          <v-list width="240" class="pa-2 overflow-hidden">
            <div class="user-display-box">
              <p class="label">E-mail</p>
              <p class="value text-truncate">{{ user.email || "user@example.com" }}</p>
            </div>

            <!-- <v-list-item link class="rounded-lg mb-1">
              <v-icon small class="mr-3">mdi-account-outline</v-icon>
              <v-list-item-title class="text-body-2">My Profile</v-list-item-title>
            </v-list-item> -->

            <v-divider class="my-2 mx-2 opacity-50"></v-divider>

            <v-list-item link @click="handleLogout" class="rounded-lg logout-item">
              <v-icon small color="error" class="mr-3">mdi-logout-variant</v-icon>
              <v-list-item-title class="text-body-2 error--text font-weight-medium">ออกจากระบบ</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </v-app-bar>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { IconImg } from "@/assets/index.js";

export default {
  name: "AppBar",
  data: () => ({
    icons: IconImg,
  }),
  methods: {
    ...mapActions("authen", ["signout"]),
    async handleLogout() {
      await this.signout();
    },
  },
  computed: {
    ...mapState("authen", ["user"]),
  },
};
</script>
<style scoped>
/* 1. LAYOUT & RESET: จัดการโครงสร้างหลัก */
::v-deep .v-toolbar__content {
  padding: 0 !important; /* ล้าง padding เริ่มต้นของ Vuetify */
  display: flex;
  align-items: center;
}

.app-bar-root {
  backdrop-filter: blur(12px);
  background-color: rgba(255, 255, 255, 0.8) !important;
  border-bottom: 1px solid rgba(241, 245, 249, 0.8) !important;
}

.app-bar-container {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 24px; /* px-6 */
}

/* 2. TYPOGRAPHY: จัดการตัวอักษร */
.txt-caption { font-size: 0.75rem; font-weight: 500; }
.txt-subtitle { font-size: 0.875rem; font-weight: 700; }
.slate-400 { color: #94a3b8; }
.slate-700 { color: #334155; }

/* 3. BREADCRUMB: ส่วนนำทาง */
.header-breadcrumb {
  line-height: 1;
}

/* 4. PROFILE PILL: ปุ่มโปรไฟล์ */
.profile-pill {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.profile-pill:hover {
  background: #f8fafc;
}

.profile-info {
  margin-left: 12px;
  text-align: left;
}

.u-name {
  font-size: 0.875rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
  max-width: 120px;
}

.u-role {
  font-size: 0.75rem;
  color: #64748b;
  display: flex;
  align-items: center;
  margin-top: 2px;
  line-height: 1;
}

.status-indicator {
  width: 6px;
  height: 6px;
  background: #22c55e;
  border-radius: 50%;
  margin-right: 6px;
}

/* 5. COMPONENTS: ส่วนประกอบย่อย */
.v-divider-vertical {
  width: 1px;

  /* height: 20px; */
  background-color: #e2e8f0;
}

.menu-dropdown-shadow {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 
              0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

.user-display-box {
  padding: 12px 16px;
  margin-bottom: 8px;
  background-color: #f8fafc;
  border-radius: 8px;
}

.user-display-box .label {
  font-size: 0.65rem;
  font-weight: 800;
  color: #94a3b8;
  margin-bottom: 0;
}

.user-display-box .value {
  font-size: 0.800em;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 0;
}

.logout-item:hover {
  background-color: #fff1f2 !important;
}
</style>